<template>
	<AppBottomSheet :forceWidth="bottomSheetWidth" :active="showBottomSheet" @toggling-popup="(open) => $emit('toggling-popup', open)">
		<ModalHeader :title="getString('executed_by_title')" :button-text="getString('apply')" @click-button="applyExecutedByFilter" />

		<AppList :items="executedByOptions">
			<template #userDropdown>
				<div class="row space-between align-center all-options pointer" @click="toggleAll">
					<div class="checkbox">
						<AppCheckbox :is-active="allUsersSelected" :auto-toggle="false"/>
					</div>
					<p class="mr-18">{{getString('users_number')}}</p>
				</div>
				<div class="rounded-borders">
					<AppList :items="userList">
						<template #checkboxElement="{item}">
							<div class="row space-between align-center pointer" @click="toggleCheckbox(item.userId)">
								<div class="checkbox">
									<AppCheckbox :is-active="item.active" :auto-toggle="false"/>
								</div>
								<p class="mr-18">{{item.name}}</p>
							</div>
						</template>
					</AppList>
				</div>
			</template>
		</AppList>
	</AppBottomSheet>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppCheckbox from "@/shared/components/AppCheckbox.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		const userStore = useUserStore();
		return {getString: useLanguageStore().getString, userStore};
	},
	data() {
		return {
			currentUserToFilterBy: true,
			currentListOfUserToFilterBy: {},
		};
	},
	mixins: [WindowWidth],
	props: {
		value: {
			type: Object,
			default: {
				userToFilterBy: true,
				listOfUserToFilterBy: {},
				typeOfUserToFilterBy: 0,
				onlineClient: true
			},
		},
		showBottomSheet: {
			type: Boolean,
			default: false
		},
		noFilterType: {
			type: Boolean,
			default: false
		}
	},
	name: "ExecutedByFilter" ,
	components: {ModalHeader, AppCheckbox, AppList, AppBottomSheet},
	emits: ['filter-value-selected', 'toggling-popup'],
	computed: {
		executedByOptions() {
			let result = [];
			if(!this.noFilterType) {
				result.push({
					title: this.getString("filter_by"),
					selectedIndex: this.value.typeOfUserToFilterBy,
					selectValues: [
						this.getString("order_creation"),
						this.getString("order_payment"),
					],
					callbackSelect: val => this.value.typeOfUserToFilterBy = val
				});
			}
			result = result.concat([
				{
					title: this.getString("users_number"),
					switch: true,
					active: this.currentUserToFilterBy,
					callback: active => this.currentUserToFilterBy = active,
					dropdownSlot: "userDropdown"
				},
				{
					title: this.getString("online_client"),
					switch: true,
					active: this.value.onlineClient,
					callback: active => this.value.onlineClient = active
				}
			]);
			return result;
		},
		userList() {
			if(!this.userStore.businessUsers) { return []; }
			return Object.values(this.userStore.businessUsers).map(user => {
				return {
					title: null,
					userId: user.user_id,
					customSlot: "checkboxElement",
					name: user.name,
					backgroundColor: "var(--color-bg)",
					active: this.currentListOfUserToFilterBy ? this.currentListOfUserToFilterBy[parseInt(user.user_id)] : false,
				};
			});
		},
		allUsersSelected() {
			if(!this.userStore.businessUsers) { return true; }
			return Object.values(this.currentListOfUserToFilterBy ?? {}).filter(value => { return value === true }).length === Object.values(this.userStore.businessUsers).length;
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else {
				return "960px";
			}
		},
	},
	methods: {
		applyExecutedByFilter() {
			let value = {
				typeOfUserToFilterBy: this.value.typeOfUserToFilterBy,
				userToFilterBy: this.currentUserToFilterBy,
				listOfUserToFilterBy: JSON.parse(JSON.stringify(this.currentListOfUserToFilterBy)),
				onlineClient: this.value.onlineClient
			};

			this.$emit('filter-value-selected', value);
		},
		toggleCheckbox(userId) {
			this.currentListOfUserToFilterBy[userId] = !this.currentListOfUserToFilterBy[userId];
		},
		toggleAll() {
			if(this.allUsersSelected) {
				Object.keys(this.currentListOfUserToFilterBy).map(userId => {
					this.currentListOfUserToFilterBy[userId] = false;
				});
			} else {
				Object.keys(this.currentListOfUserToFilterBy).map(userId => {
					this.currentListOfUserToFilterBy[userId] = true;
				});
			}
		},
		loadUsersToFilterBy() {
			this.currentListOfUserToFilterBy = {};
			Object.values(this.userStore.businessUsers).forEach(user => {
				this.currentListOfUserToFilterBy[parseInt(user.user_id)] = true;
			});
			this.$emit('filter-value-selected', {
				typeOfUserToFilterBy: this.value.typeOfUserToFilterBy,
				userToFilterBy: this.currentUserToFilterBy,
				listOfUserToFilterBy: JSON.parse(JSON.stringify(this.currentListOfUserToFilterBy)),
				onlineClient: this.value.onlineClient
			});
		}
	},
	mounted() {
		if(!this.userStore.businessUsers || !Object.keys(this.userStore.businessUsers).length) {
			this.userStore.getBusinessUsers(this.loadUsersToFilterBy);
		} else {
			this.loadUsersToFilterBy()
		}
	},
	watch: {
		'userStore.currBusinessId': function(newVal, oldVal) {
			if(newVal !== null && newVal !== oldVal) {
				this.userStore.getBusinessUsers(this.loadUsersToFilterBy);
			}
		}
	}
}
</script>

<style scoped>
.rounded-borders {
	:deep(.list-item:first-child) {
		border-top-left-radius: 13px;
		border-top-right-radius: 13px;
	}

	:deep(.list-item:last-child) {
		border-bottom-left-radius: 13px;
		border-bottom-right-radius: 13px;
	}
}
.all-options {
	background-color: var(--color-alpha-1);
	padding: 15px 10px;
	border-radius: 13px;
	margin-bottom: 9px;
}
.checkbox {
	width: 30px;
	height: 30px;
}
</style>